module.exports = __webpack_public_path__ + "./fonts/Kodchasan-Bold.ttf";